export default class ContactForm {

  #dom = {};

  constructor(element) {
    this.#dom.element = element;    
    this.bindEventListeners();    
  }

  bindEventListeners() {
    window.multiselects.subject.element-addEventListener('change', this.#contactFormOptions.bind(this));
    window.multiselects.brands.element.addEventListener('change', this.#contactFormOptions.bind(this));    
  }

  async #contactFormOptions() {

    const [subject] = window.multiselects.subject.getValue();

    const blandSlugs = Array.from( window.multiselects.brands.element.options )
      .filter((option) => option.selected )
      .map( option => option.value);

    const urlSearchParameters = new URLSearchParams({ subject: subject, brands: blandSlugs })
    
    const response = await fetch('/stage-ajax/contact-form-locations?' + urlSearchParameters.toString());
    const responseData = await response.json();
        
    const lastSelectedOptions = Array.from( window.multiselects.location.element.options )
      .filter((option) => option.selected );      

    const options = responseData.map((location) => {
      return {
        value: location.value, 
        shownValue: location.text,
        selected: lastSelectedOptions.some((option) => option.value === location.value)
      }
    });

    if( options.length === 1 ) {
      options[0].selected = true;
    }

    window.multiselects.location.removeAllOptions(false, true);
    window.multiselects.location.addOptions(options);
  }



  static init() {
    document.querySelectorAll('.hedin-contact-form').forEach((form) => {
      new ContactForm(form);
    });
  }
}